import { Icon, IconProps } from "@blueprintjs/core";

export function PivotPlaceholder(props: { icon: IconProps["icon"] }) {
  return (
    <div className="pivot-placeholder-container">
      <Icon icon={props.icon} iconSize={48}></Icon>
    </div>
  );
}
